import React from 'react';
import { motion } from 'framer-motion';

const industries = [
  "Ecommerce", "SaaS & Tech", "Real Estate", 
  "Restaurants", "Healthcare", "Coaches & Consultants", 
  "Local Businesses", "Agencies"
];

const VideoIndustries = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-slate-900 rounded-[3rem] p-12 md:p-20 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 blur-[80px]" />
          
          <div className="relative z-10 text-center mb-16">
            <h2 className="text-emerald-400 font-black text-sm uppercase tracking-[0.2em] mb-4">Versatility</h2>
            <p className="text-3xl md:text-5xl font-extrabold text-white">Industries We Serve</p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 relative z-10">
            {industries.map((item, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                className="px-8 py-4 bg-white/5 border border-white/10 rounded-2xl text-white font-bold text-lg hover:border-emerald-400/50 transition-all cursor-default"
              >
                {item}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoIndustries;
